import React from "react";

import { pickMillions } from "./utils";
import OnePanelChart from "./OnePanelChart";
import Formula from "./Formula";
import Text from "./Text";

const Revenues = ({ teams, competitionMetrics }) => (
  <OnePanelChart
    title="Net Revenues"
    data={pickMillions(teams, competitionMetrics, "Net Revenues")}
    prefix="$"
    suffix="M"
    precision={3}
    teams={teams}
  >
    <Text>
      Revenues are the total dollar sales that a business might generate within
      a period of time. It is calculated by taking the number of units sold
      multiplied by the selling price of each unit:
      <br />
    </Text>
    <Formula>REVENUES = UNIT SALES &#215; UNIT SELLING PRICE</Formula>
  </OnePanelChart>
);

export default Revenues;



// WEBPACK FOOTER //
// ./src/components/analysis/Revenues.js